import marked from 'marked'

// declare module 'vue/types/vue' {
//   interface Vue {
//     $md: typeof marked;
//   }
// }

const renderer = new marked.Renderer()

renderer.link = (href, title, text) =>
  `<a target="_blank" href="${href}" title="${title}">${text}</a>`

const $md = (md: string) => marked(md, { renderer })

export default $md
